import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms'; // Already added
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import Aura from '@primeng/themes/aura';
import {
  provideNgxWebstorage,
  withLocalStorage,
  withNgxWebstorageConfig,
  withSessionStorage,
} from 'ngx-webstorage';
import { httpInterceptorProviders } from './core/interceptor';
import { AuthModule } from './auth/auth.module';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationConfigService } from './core/config/application-config.service';
import { environment } from 'src/environments/environment';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MainComponent } from './layout/main/main.component';
import { FooterComponent } from './layout/footer/footer.component';
import { Menu } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { HrmsRoutingModule } from './hrms/hrms-routing.module';
import { SharedModule } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { TicketModule } from './tickets/ticket.module';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    FooterComponent,
    NavbarComponent,
    // Remove RoleEditComponent from declarations
  ],
  bootstrap: [MainComponent], // Ensure this is intentional
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HrmsRoutingModule,
    AuthModule,
    NgxSpinnerModule,
    MenubarModule,
    Menu,
    BadgeModule,
    SharedModule,
    TicketModule,
  ],
  providers: [
    httpInterceptorProviders,
    provideNgxWebstorage(
      withNgxWebstorageConfig({
        prefix: 'jhi',
        separator: '-',
        caseSensitive: true,
      }),
      withLocalStorage(),
      withSessionStorage()
    ),
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
  ],
})
export class AppModule {
  constructor(private applicationConfig: ApplicationConfigService) {
    applicationConfig.setEndpointPrefix(environment.SERVER_API_URL);
    console.log('AppModule initialized');
  }
}
